export const TARIFF_PLANS = {
  standard: 'standard',
  advanced: 'advanced',
  start: 'start',
};

export const TARIFF_PLANS_INFO = {
  [TARIFF_PLANS.standard]: {
    label: 'Standard',
    flat_fee: '9%',
    monthly_repayment: '2%',
    upfront_fee: '4.05%',
    first_5_months: '2%',
    remaining_principal_6th: '90%',
    outstanding_flat_fee_6th: '4.95%',
  },
  [TARIFF_PLANS.advanced]: {
    label: 'Advanced',
    flat_fee: '6%',
    monthly_repayment: '8%',
    upfront_fee: '1.725%',
    first_5_months: '8%',
    remaining_principal_6th: '60%',
    outstanding_flat_fee_6th: '4.275%',
  },
  [TARIFF_PLANS.start]: {
    label: 'Start',
    flat_fee: '6%',
    monthly_repayment: '8%',
    upfront_fee: '1.725%',
    first_5_months: '8%',
    remaining_principal_6th: '60%',
    outstanding_flat_fee_6th: '4.275%',
  },
};

export const LAST_UPDATED = '2024-04-01';
